import React from 'react'
import * as Config from '../../public/external-links'
import './MyAccountFooter.css'

const MyAccountFooter = () => {
  return (
    <>
      <footer className="site-links">
        <a href={`${Config.HOME_ACCESSIBILITY_URL}`}>Accessibility</a>

        <a href={`${Config.HOME_COPYRIGHT_URL}`}>Copyright</a>

        <a href={`${Config.HOME_DISCLAIMER_URL}`}>Disclaimer</a>

        <a href={`${Config.HOME_PRIVACY_URL}`}>Privacy</a>
      </footer>
    </>
  )
}

export default MyAccountFooter
